const STORAGE_KEY = 'tracking:referrer';

export default () => {
  const register = () => {
    if (document.referrer) {
      const referrerUrl = new URL(document.referrer);

      if (referrerUrl.origin !== window.location.origin) {
        localStorage.setItem(STORAGE_KEY, document.referrer);
      }
    }
  };

  register();

  return localStorage.getItem(STORAGE_KEY);
};
